import { render, staticRenderFns } from "./OperationList.vue?vue&type=template&id=4963f748&"
import script from "./OperationList.vue?vue&type=script&lang=js&"
export * from "./OperationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports